import { navigationFeatureEnabled } from '@app/helpers'

import { allowedPatterns, b2cReferrerPatterns } from './patterns'

export const checkReferrer = (referrer: string | null) => {
  if (!referrer || referrer === '') return false

  if (navigationFeatureEnabled()) {
    return b2cReferrerPatterns.some((pattern) => pattern.test(referrer))
  }

  const exclusionPattern =
    /(.*\.properstar\.com|.*\.listglobally\.com).*\/(leads|messages|my-profile\/settings\?returnurl)/
  if (exclusionPattern.test(referrer)) {
    return false
  }

  return allowedPatterns.some((pattern) => pattern.test(referrer))
}
